



















































import {
  defineComponent,
  computed,
  PropType,
  ref
} from '~/utils/nuxt3-migration'
import { useRoute, useRouter } from '@nuxtjs/composition-api'
import { useDep } from '~/compositions/dependency-container'
import ScrollService from '~/services/scroll/ScrollService'
import { BottomMenuItem } from '~/models/header/bottom-menu-item'
import { useNamespacedStore } from '~/compositions/store'
import { USER_NS, UserState } from '~/store/modules/shared/user/state'
import HeaderUserMenu from '~/components/car/header/HeaderUserMenu.vue'

export default defineComponent({
  components: { HeaderUserMenu },
  props: {
    item: {
      type: Object as PropType<BottomMenuItem>,
      required: true
    }
  },
  setup(props) {
    const route = useRoute()
    const router = useRouter()

    const scrollService = useDep(ScrollService)

    const { state } = useNamespacedStore<UserState>(USER_NS)
    const avatar = computed(() => state.avatar)
    const username = computed(() => state.username)

    const { getters: userGetters } = useNamespacedStore<UserState>(USER_NS)
    const isSingle = computed(() => userGetters('isSingle'))

    const showSingleModal = ref(false)

    const isLoginRelatedRoute = computed(() => {
      return [
        '__login',
        '__guest_register',
        '__password_reset',
        '__password_set'
      ].some(r => route.value.name === r)
    })

    const isOtherAccountNavItem = computed(() => {
      return [
        '__account_notifications',
        '__account_parking',
        '__account_searches',
        '__account_audits_external_certificates',
        '__account_audits_requests'
      ].some(r => Boolean(route.value.name?.startsWith(r)))
    })

    const isActive = computed(() => {
      const routeName = props.item.to.name

      const routeStartsWithRouteName = Boolean(
        route.value.name?.startsWith(routeName)
      )

      const goToNotificationsNext =
        route.value.query?.gotonext ===
        router.resolve({ name: '__account_notifications' }).route.fullPath

      if (routeName === '__account') {
        return (
          (routeStartsWithRouteName && !isOtherAccountNavItem.value) ||
          (isLoginRelatedRoute.value && !goToNotificationsNext)
        )
      } else if (routeName === '__account_notifications') {
        return (
          routeStartsWithRouteName ||
          (isLoginRelatedRoute.value && goToNotificationsNext)
        )
      }
      return routeStartsWithRouteName
    })

    const isSingleItem = computed(
      () => isSingle.value && props.item.to.name === '__classifieds_view'
    )

    function onItemClick(e: Event) {
      if (!process.client) {
        return
      }

      if (isSingleItem.value) {
        e.preventDefault()
        showSingleModal.value = true
        return
      }

      if (isActive.value) {
        // for example __account_notifications goes to -> __account_notifications_list
        const routeMainPagesRedirected = [
          '__account_notifications_list',
          '__account_parking_classifieds_favorite',
          '__account_searches_favorite'
        ]
        if (
          !routeMainPagesRedirected.includes(route.value.name) &&
          route.value.name !== props.item.to.name
        ) {
          // we are probably on a child route so dont prevent, just go to the route
          return
        }

        e.preventDefault()
        if (window.scrollY > 0) {
          scrollService.scrollToTopSmooth()
        } else {
          window.location.reload()
        }
      } else {
        scrollService.scrollToTop({ duration: 0 })
      }
    }

    const iconToShow = computed(() => {
      return isActive.value
        ? props.item.activeIcon || props.item.icon
        : props.item.icon
    })

    function onUserMenuClick() {
      showSingleModal.value = false
      scrollService.scrollToTop({ duration: 0 })
    }

    return {
      isActive,
      onItemClick,
      avatar,
      username,
      iconToShow,
      isSingle,
      showSingleModal,
      onUserMenuClick,
      isSingleItem
    }
  }
})
